import { nanoid } from 'nanoid';
// 记录页面加载的起始时间（毫秒）
let startTimestamp = Date.now();
const frontSId = `${nanoid(25)}_${Math.random().toString().slice(2, 12)}`;
const reportedEvents = new Set();

/**
 * 重置起始时间（在需要的时候手动调用）
 * @returns {number} 新的起始时间戳
 */
export const resetStartTime = () => {
  startTimestamp = Date.now();
  return startTimestamp;
};

/**
 * 获取当前耗时（毫秒）
 * @returns {number} 从起始时间到现在的耗时（毫秒）
 */
export const getCurrentDuration = () => {
  return Date.now() - startTimestamp;
};

/**
 * 统一的打点辅助函数
 * @param {string} eventName - 事件名称
 * @param {object} extraData - 额外数据
 * @param {string} pageType - 页面类型
 */
export const trackStagePoint = (eventName, extraData = {}) => {
  try {
    if (reportedEvents.has(eventName)) {
      return;
    }

    window?.webstorev35DataLayer?.push({
      eventName,
      eventType: extraData?.eventType || 'select_stage',
      ...(extraData?.eventReason && { eventReason: extraData.eventReason }),
      eventValue: {
        frontSId,
        timestamp: Date.now(),
        duration: Date.now() - startTimestamp, // 耗时（毫秒）
        ...Object.keys(extraData).reduce((acc, key) => {
          if (key !== 'eventType' && key !== 'eventReason') {
            acc[key] = extraData[key];
          }
          return acc;
        }, {})
      }
    });
    window?.webstorev35DataLayerBatch?.push({
      eventName,
      eventType: extraData?.eventType || 'select_stage',
      ...(extraData?.eventReason && { eventReason: extraData.eventReason }),
      eventValue: {
        frontSId,
        timestamp: Date.now(),
        duration: Date.now() - startTimestamp, // 耗时（毫秒）
        ...Object.keys(extraData).reduce((acc, key) => {
          if (key !== 'eventType' && key !== 'eventReason') {
            acc[key] = extraData[key];
          }
          return acc;
        }, {})
      }
    });
    reportedEvents.add(eventName);
  } catch (error) {
    console.error(error);
  }
};
